import user from './user'
import token from './token'
import menus from './menus'
import gmt from './gmt'
import language from './language'
import dataCenter from './data-center'

export default { user, token, menus, gmt, language, dataCenter }
